import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/auth';
import permissionReducer from './slices/permission';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    permission: permissionReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
